// API Configuration
// Centralized API base URL configuration

// Build-time constant - this will be 'https://copilot-api...' in production builds
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

export { API_BASE_URL };
